module.exports = __webpack_public_path__ + "static/media/c4cc9032-7eee-4a6e-ae8b-f384b1349bcf.d310a85c.woff2";